<template>
	<span class="wrapper">
		<input v-model="Value" type="text" @focus="onFocus" @blur="onBlur" @keydown="onKeyDown" @input="onInput" class="input" />
		<span class="fix">{{ fixed }}</span>
	</span>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'domainInput',
	//=========================================================================
	// свойства, задаются только родителем
	//=========================================================================
	props: [
		// текущее значение модели
		'value',
		// фиксирование значение
		'fixed'
	],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// текущее значение поля
			Value: ''
		}
	},
	//=========================================================================
	// событие: при создании компонента и перед монтированием его в DOM
	//=========================================================================
	created() {
		this.Value = this.value
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// событие: фокус
		//---------------------------------------------------------------------
		onFocus() {
			this.$emit('focus')
		},
		//---------------------------------------------------------------------
		// событие: потеря фокуса
		//---------------------------------------------------------------------
		onBlur() {
			// сообщим родителю о смене значения
			this.$emit('input', this.Value)
			// сообщаем родителю что потеряли фоксу
			this.$emit('blur')
		},
		//---------------------------------------------------------------------
		// событие: keydown
		//---------------------------------------------------------------------
		onKeyDown(e) {
			// если это был Enter - тоже сообщим родителю
			if (e.keyCode === 13 || e.which === 13) this.$emit('keydownEnter')
		},
		//---------------------------------------------------------------------
		// событие: change
		//---------------------------------------------------------------------
		onInput(e) {
			// сообщим родителю о смене значения
			this.$emit('input', this.Value)
		}
		//---------------------------------------------------------------------
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.wrapper {
	display: inline-block;
	width: 100%;
}
.input {
	float: left;
	display: inline-block;
	width: 60% !important;
	border-radius: 4px 0 0 4px !important;
}
.fix {
	clear: both;
	display: inline-block;
	width: 40%;
	height: 3em;
	line-height: 3em;
	background: #eee;
	border: 1px solid #ddd;
	border-left: 0;
	border-radius: 0 4px 4px 0;
	padding: 0 10px;
	font-weight: 400;
	overflow: hidden;
	text-overflow: ellipsis;
}

@media (max-width: 767px) {
	.input {
		width: 70% !important;
	}
	.fix {
		width: 30% !important;
	}
}
</style>



// WEBPACK FOOTER //
// domain.vue?6408d003